import api from "../index";

export const GetTicketCountApi = () => api.get('ticket/getallticket-countlist');
export const GetAllTicketApi = (params) => api.get(`ticket/get-all-tickets?${params}`);
export const GetTicketByIdApi = (ticketId) => api.get(`ticket/get-ticket-details-byid/${ticketId}`);
export const UpdateTicketApi = (data) => api.post('ticket/update-ticket-status', data);
export const GetTicketChatApi = (data, headers) => api.post('ticket/add-ticket-detail', data, headers);